import React from 'react';
import { Hero } from '../components/Hero';
import { TrustedCompanies } from '../components/TrustedCompanies';
import { Testimonials } from '../components/Testimonials';
import { BusinessProblems } from '../components/BusinessProblems';
import { WhatWeAreNot } from '../components/WhatWeAreNot';
import { HowWeHelp } from '../components/HowWeHelp';
export function Home() {
  return <>
      <Hero data-id="element-171" />
      <TrustedCompanies data-id="element-172" />
      <Testimonials data-id="element-173" />
      <BusinessProblems data-id="element-174" />
      <WhatWeAreNot data-id="element-175" />
      <HowWeHelp data-id="element-176" />
    </>;
}